import * as d3 from 'd3';
import { GAS_LIMIT } from '../utils/constants.js';

function transactionLink(txhash) {
    return "https://etherscan.io/tx/" + txhash
}

function shortAddress(address) {
    if (address.length >= 10) {
        var firstFive = address.slice(0, 5);
        var lastFive = address.slice(-5);
        return firstFive + "..." + lastFive;
    } else {
        return address
    }
}

function transfersString(transfers) {
    if (transfers.length > 0) {
        var str = "<br>"
        var str = "<strong>Transfers:</strong><br>"
        for (var i = 0; i < transfers.length; i++) {
            var transfer = transfers[i]
            str += `- ${transfer.s} : ${transfer.q / Math.pow(10, transfer.d)} ${shortAddress(transfer.f)} > ${shortAddress(transfer.t)}<br>`
        }
        return str
    } else {
        return ""
    }
}

export default class BlockCompositionUI {

    constructor(block_composition_value_div, block_composition_gas_div) {
        this.padding = { top: 20, right: 5, bottom: 5, left: 5 };
        this.format4 = d3.format('.4f');
        this.format2 = d3.format('.2f');

        var parentDivValue = document.querySelector(block_composition_value_div);
        var rectValue = parentDivValue.getBoundingClientRect();
        this.heightValueDiv = rectValue.height;
        this.widthValueDiv = rectValue.width;

        var parentDivGas = document.querySelector(block_composition_gas_div);
        var rectGas = parentDivGas.getBoundingClientRect();
        this.heightGasDiv = rectGas.height;
        this.widthGasDiv = rectGas.width;

        this.setupValueGraph(block_composition_value_div)
        this.setupValueToolTip(block_composition_value_div)
        this.setupGasGraph(block_composition_gas_div)
        this.setupGasToolTip(block_composition_gas_div)
    }

    setBlockInfo = (block_info) => {
        this.setTransactions(block_info.transactions)
    }

    setTransactions = (transactions) => {
        const resultValue = xPos(transactions, ['tip_reward', 'coinbase'], 'position')
        this.drawTxsValue(resultValue)
        const resultGas = xPos(transactions, ['gas_used'], 'position')
        this.drawTxsGas(resultGas)
    }

    setupValueGraph = (block_composition_value_div) => {

        this.svgValue = d3.select(block_composition_value_div).append("svg")
            .attr("width", this.widthValueDiv)
            .attr("height", this.heightValueDiv)

        this.xValuePctScale = d3.scaleLinear()
            .domain([0, 100])
            .range([this.padding.left, this.widthValueDiv - this.padding.right])

        this.yValueScale = d3.scaleBand()
            .domain([0])
            .range([this.heightValueDiv - this.padding.bottom, this.padding.top]);

        this.hlineValue1 = this.svgValue.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthValueDiv - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.padding.top)
            .style("stroke-width", "1.5")
            .style("stroke", "#d3d3d3");

        this.hlineValue2 = this.svgValue.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthValueDiv - this.padding.right)
            .attr('y1', this.heightValueDiv - this.padding.bottom)
            .attr('y2', this.heightValueDiv - this.padding.bottom)
            .style("stroke-width", "1.5")
            .style("stroke", "#d3d3d3");

        this.vlineValue1 = this.svgValue.append('line')
            .attr('x1', this.xValuePctScale(0))
            .attr('x2', this.xValuePctScale(0))
            .attr('y1', this.padding.top)
            .attr('y2', this.heightValueDiv - this.padding.bottom)
            .attr('stroke-width', '1.5')
            .attr('stroke', '#d3d3d3')

        this.vlineValue2 = this.svgValue.append('line')
            .attr('x1', this.widthValueDiv - this.padding.right)
            .attr('x2', this.widthValueDiv - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.heightValueDiv - this.padding.bottom)
            .attr('stroke-width', '1.5')
            .attr('stroke', '#d3d3d3')
    }

    setupValueToolTip = (block_composition_value_div) => {
        // Add a tooltip div. Here I define the general feature of the tooltip: stuff that do not depend on the data point.
        // Its opacity is set to 0: we don't see it by default.
        this.tooltipValue = d3.select(block_composition_value_div)
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")

        // A function that change this tooltip when the user hover a point.
        // Its opacity is set to 1: we can now see it. Plus it set the text and position of tooltip depending on the datapoint (d)
        this.mouseoverValue = (e, transaction) => {
            // highlight rect
            const rectClass = `tx-block-composition-position-${transaction.position}`;
            const rects = d3.selectAll("rect") // Replace "div" with the appropriate selector for your div elements
                .filter(function () {
                    return this.classList.contains(rectClass);
                });
            rects.classed("highlighted", true);
            // highlight row
            const rowClass = `tx-table-row-position-${transaction.position}`;
            // Find the row element with the corresponding class
            const rowElement = document.querySelector(`.${rowClass}`);
            if (rowElement) {
                // Add a new class to the element
                rowElement.classList.add('highlighted');
            }

            this.tooltipValue = this.tooltipValue
                .style("opacity", 1)
        }

        this.mousemoveValue = (e, transaction) => {
            const [x, y] = d3.pointer(e);

            // Calculate the tooltip position relative to the mouse cursor
            const tooltipOffsetX = 10; // Add an offset to adjust the position
            const tooltipOffsetY = 10; // Add an offset to adjust the position
            const tooltipLeft = x + tooltipOffsetX;
            const tooltipTop = y + tooltipOffsetY;

            var method_id = "";
            if (transaction.method_id !== "") {
                method_id = `<strong style="display: inline-block; width: 100px;">Method Id:</strong> ${transaction.method_id}<br>`
            }
            var method = "";
            if (transaction.method !== "" && transaction.method !== "<unknown>") {
                var methods = transaction.method.split(";");
                if (methods.length > 1) {
                    const maxDisplayed = 5;
                    const numHidden = methods.length - maxDisplayed;
                    if (numHidden > 0) {
                        methods = methods.slice(0, maxDisplayed);
                        methods.push("..." + numHidden + " more");
                    }
                    methods = methods.join(`<br><strong style="display: inline-block; width: 100px;"></strong> `)
                    method = `<strong style="display: inline-block; width: 100px;">Method:</strong> ${methods}<br>`;
                } else {
                    method = `<strong style="display: inline-block; width: 100px;">Method:</strong> ${transaction.method}<br>`;
                }
            }

            this.tooltipValue = this.tooltipValue
                .html(`
                <div class='tooltip-tx'>
                    <strong>Hash ${transaction.hash}</strong><br><br>
                    <strong style="display: inline-block; width: 100px;">Position:</strong> ${transaction.position}<br>
                    <strong style="display: inline-block; width: 100px;">Class:</strong> ${transaction.class.toUpperCase()}<br>
                    <strong style="display: inline-block; width: 100px;">From:</strong> ${transaction.from}<br>
                    <strong style="display: inline-block; width: 100px;">To:</strong> ${transaction.to}<br>
                    ${method}
                    ${method_id}
                    <strong style="display: inline-block; width: 100px;">Value:</strong> ${transaction.value} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Gas Used:</strong> ${transaction.gas_used}<br>
                    <strong style="display: inline-block; width: 100px;">Tip:</strong> ${(transaction.tip * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Tip Reward:</strong> ${transaction.tip_reward} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Coinbase:</strong> ${transaction.coinbase} ETH<br>
                    ${transfersString(transaction.transfers)}
                </div>
                `)

            const tooltipElement = this.tooltipValue.node();
            const tooltipWidth = tooltipElement.offsetWidth; // Get the actual width of the tooltip

            // Check if the tooltip width exceeds the screen size
            if (e.clientX + tooltipWidth + tooltipOffsetX > window.innerWidth) {
                // Adjust the tooltip position to be on the left of the mouse cursor
                const leftOffset = -tooltipWidth;
                this.tooltipValue.style("left", `${x + leftOffset}px`);
            } else {
                this.tooltipValue.style("left", `${tooltipLeft}px`);
            }

            this.tooltipValue.style("top", `${tooltipTop - this.heightValueDiv}px`);
        }

        // A function that change this tooltip when the leaves a point: just need to set opacity to 0 again
        this.mouseleaveValue = (e, transaction) => {
            const rectClass = `tx-block-composition-position-${transaction.position}`;
            const rects = d3.selectAll("rect") // Replace "div" with the appropriate selector for your div elements
                .filter(function () {
                    return this.classList.contains(rectClass);
                });
            rects.classed("highlighted", false);

            const rowClass = `tx-table-row-position-${transaction.position}`;
            // Find the row element with the corresponding class
            const rowElement = document.querySelector(`.${rowClass}`);
            if (rowElement) {
                // Add a new class to the element
                rowElement.classList.remove('highlighted');
            }

            this.tooltipValue = this.tooltipValue
                .html("")
                .style("left", `0px`)
                .style("top", `0px`)
                .style("opacity", 0)
        }

        this.clickTx = (e, d) => {
            window.open(transactionLink(d.hash), '_blank');
        }
    }

    drawTxsValue = (result) => {
        this.xValuePctScale.domain([0, result.total])

        if (this.xlabelValue !== undefined) {
            this.xlabelValue.remove()
        }

        // X label
        this.xlabelValue = this.svgValue.append('text')
            .attr('x', this.widthValueDiv / 2)
            .attr('y', this.padding.top / 2)
            .attr('text-anchor', 'middle')
            .style('font-family', 'Courier,Courier New,slab-serif')
            .style('font-size', 8)
            .style('fill', '#d3d3d3')
            .text(`Block Value ${(result.total).toFixed(8)} ETH`);

        if (this.valueBars !== undefined) {
            this.valueBars.remove()
        }
        // draw pct bars
        this.valueBars = this.svgValue.append("g")
            .selectAll()
            .data(result.transactions)
            .join("rect")
            .attr("class", d => `tx-block-composition-position-${d.position}`)
            .attr("fill", d => getColorByClass(d.class))
            .attr("x", d => this.xValuePctScale(d.x_pos))
            .attr("y", this.yValueScale(0)) // always the one band
            .attr("width", d => this.xValuePctScale(d.x_width) - this.xValuePctScale(0))
            .attr("height", this.yValueScale.bandwidth())
            .style("fill-opacity", 0.50) // Adjust the opacity level here (0.0 to 1.0)
            .style("stroke", "#202124") // Add a subtle border color
            .style("stroke-width", "0.1px") // Adjust the border width as desired
            .on("mouseover", (event, d) => {
                this.mouseoverValue(event, d);
            })
            .on("mousemove", (event, d) => {
                this.mousemoveValue(event, d);
            })
            .on("mouseleave", (event, d) => {
                this.mouseleaveValue(event, d);
            })
            .on("click", (event, d) => {
                this.clickTx(event, d);
            })
    }

    setupGasGraph = (block_composition_gas_div) => {

        this.svgGas = d3.select(block_composition_gas_div).append("svg")
            .attr("width", this.widthGasDiv)
            .attr("height", this.heightGasDiv)

        this.xGasPctScale = d3.scaleLinear()
            .domain([0, 100])
            .range([this.padding.left, this.widthGasDiv - this.padding.right])

        this.yGasScale = d3.scaleBand()
            .domain([0])
            .range([this.heightGasDiv - this.padding.bottom, this.padding.top]);

        this.hlineGas1 = this.svgGas.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthGasDiv - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.padding.top)
            .style("stroke-width", "1.5")
            .style("stroke", "#d3d3d3");

        this.hlineGas2 = this.svgGas.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthGasDiv - this.padding.right)
            .attr('y1', this.heightGasDiv - this.padding.bottom)
            .attr('y2', this.heightGasDiv - this.padding.bottom)
            .style("stroke-width", "1.5")
            .style("stroke", "#d3d3d3");

        this.vlineGas1 = this.svgGas.append('line')
            .attr('x1', this.xGasPctScale(0))
            .attr('x2', this.xGasPctScale(0))
            .attr('y1', this.padding.top)
            .attr('y2', this.heightGasDiv - this.padding.bottom)
            .attr('stroke-width', '1.5')
            .attr('stroke', '#d3d3d3')

        this.vlineGas2 = this.svgGas.append('line')
            .attr('x1', this.widthGasDiv - this.padding.right)
            .attr('x2', this.widthGasDiv - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.heightGasDiv - this.padding.bottom)
            .attr('stroke-width', '1.5')
            .attr('stroke', '#d3d3d3')
    }

    setupGasToolTip = (block_composition_gas_div) => {
        // Add a tooltip div. Here I define the general feature of the tooltip: stuff that do not depend on the data point.
        // Its opacity is set to 0: we don't see it by default.
        this.tooltipGas = d3.select(block_composition_gas_div)
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")

        // A function that change this tooltip when the user hover a point.
        // Its opacity is set to 1: we can now see it. Plus it set the text and position of tooltip depending on the datapoint (d)
        this.mouseoverGas = (e, transaction) => {
            // highlight rect
            const rectClass = `tx-block-composition-position-${transaction.position}`;
            const rects = d3.selectAll("rect") // Replace "div" with the appropriate selector for your div elements
                .filter(function () {
                    return this.classList.contains(rectClass);
                });
            rects.classed("highlighted", true);
            // highlight row
            const rowClass = `tx-table-row-position-${transaction.position}`;
            // Find the row element with the corresponding class
            const rowElement = document.querySelector(`.${rowClass}`);
            if (rowElement) {
                // Add a new class to the element
                rowElement.classList.add('highlighted');
            }

            this.tooltipGas = this.tooltipGas
                .style("opacity", 1)
        }

        this.mousemoveGas = (e, transaction) => {
            const [x, y] = d3.pointer(e);

            // Calculate the tooltip position relative to the mouse cursor
            const tooltipOffsetX = 10; // Add an offset to adjust the position
            const tooltipOffsetY = 10; // Add an offset to adjust the position
            const tooltipLeft = x + tooltipOffsetX;
            const tooltipTop = y + tooltipOffsetY;

            var method_id = "";
            if (transaction.method_id !== "") {
                method_id = `<strong style="display: inline-block; width: 100px;">Method Id:</strong> ${transaction.method_id}<br>`
            }
            var method = "";
            if (transaction.method !== "" && transaction.method !== "<unknown>") {
                var methods = transaction.method.split(";");
                if (methods.length > 1) {
                    const maxDisplayed = 5;
                    const numHidden = methods.length - maxDisplayed;
                    if (numHidden > 0) {
                        methods = methods.slice(0, maxDisplayed);
                        methods.push("..." + numHidden + " more");
                    }
                    methods = methods.join(`<br><strong style="display: inline-block; width: 100px;"></strong> `)
                    method = `<strong style="display: inline-block; width: 100px;">Method:</strong> ${methods}<br>`;
                } else {
                    method = `<strong style="display: inline-block; width: 100px;">Method:</strong> ${transaction.method}<br>`;
                }
            }

            this.tooltipGas = this.tooltipGas
                .html(`
                <div class='tooltip-tx'>
                    <strong>Hash ${transaction.hash}</strong><br><br>
                    <strong style="display: inline-block; width: 100px;">Position:</strong> ${transaction.position}<br>
                    <strong style="display: inline-block; width: 100px;">Class:</strong> ${transaction.class.toUpperCase()}<br>
                    <strong style="display: inline-block; width: 100px;">From:</strong> ${transaction.from}<br>
                    <strong style="display: inline-block; width: 100px;">To:</strong> ${transaction.to}<br>
                    ${method}
                    ${method_id}
                    <strong style="display: inline-block; width: 100px;">Value:</strong> ${transaction.value} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Gas Used:</strong> ${transaction.gas_used}<br>
                    <strong style="display: inline-block; width: 100px;">Tip:</strong> ${(transaction.tip * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Tip Reward:</strong> ${transaction.tip_reward} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Coinbase:</strong> ${transaction.coinbase} ETH<br>
                    ${transfersString(transaction.transfers)}
                </div>
                `)

            const tooltipElement = this.tooltipGas.node();
            const tooltipWidth = tooltipElement.offsetWidth; // Get the actual width of the tooltip

            // Check if the tooltip width exceeds the screen size
            if (e.clientX + tooltipWidth + tooltipOffsetX > window.innerWidth) {
                // Adjust the tooltip position to be on the left of the mouse cursor
                const leftOffset = -tooltipWidth;
                this.tooltipGas.style("left", `${x + leftOffset}px`);
            } else {
                this.tooltipGas.style("left", `${tooltipLeft}px`);
            }

            this.tooltipGas.style("top", `${tooltipTop - this.heightGasDiv}px`);
        }

        // A function that change this tooltip when the leaves a point: just need to set opacity to 0 again
        this.mouseleaveGas = (e, transaction) => {
            const rectClass = `tx-block-composition-position-${transaction.position}`;
            const rects = d3.selectAll("rect") // Replace "div" with the appropriate selector for your div elements
                .filter(function () {
                    return this.classList.contains(rectClass);
                });
            rects.classed("highlighted", false);

            const rowClass = `tx-table-row-position-${transaction.position}`;
            // Find the row element with the corresponding class
            const rowElement = document.querySelector(`.${rowClass}`);
            if (rowElement) {
                // Add a new class to the element
                rowElement.classList.remove('highlighted');
            }

            this.tooltipGas = this.tooltipGas
                .html("")
                .style("left", `0px`)
                .style("top", `0px`)
                .style("opacity", 0)
        }

    }

    drawTxsGas = (result) => {
        this.xGasPctScale.domain([0, result.total])

        if (this.xlabelGas !== undefined) {
            this.xlabelGas.remove()
        }

        // X label
        this.xlabelGas = this.svgGas.append('text')
            .attr('x', this.widthGasDiv / 2)
            .attr('y', this.padding.top / 2)
            .attr('text-anchor', 'middle')
            .style('font-family', 'Courier,Courier New,slab-serif')
            .style('font-size', 8)
            .style('fill', '#d3d3d3')
            .text(`Gas Used ${(result.total).toFixed(0)} - ${(result.total / GAS_LIMIT * 100).toFixed(2)}%`);

        if (this.gasBars !== undefined) {
            this.gasBars.remove()
        }
        // draw pct bars
        this.gasBars = this.svgGas.append("g")
            .selectAll()
            .data(result.transactions)
            .join("rect")
            .attr("class", d => `tx-block-composition-position-${d.position}`)
            .attr("fill", d => getColorByClass(d.class))
            .attr("x", d => this.xGasPctScale(d.x_pos))
            .attr("y", this.yGasScale(0)) // always the one band
            .attr("width", d => this.xGasPctScale(d.x_width) - this.xGasPctScale(0))
            .attr("height", this.yGasScale.bandwidth())
            .style("fill-opacity", 0.50) // Adjust the opacity level here (0.0 to 1.0)
            .style("stroke", "#202124") // Add a subtle border color
            .style("stroke-width", "0.1px") // Adjust the border width as desired
            .on("mouseover", (event, d) => {
                this.mouseoverGas(event, d);
            })
            .on("mousemove", (event, d) => {
                this.mousemoveGas(event, d);
            })
            .on("mouseleave", (event, d) => {
                this.mouseleaveGas(event, d);
            })
            .on("click", (event, d) => {
                this.clickTx(event, d);
            })

    }

}

function getColorByClass(key) {
    const colorMap = new Map([
        ['eth_transfer', '#26a6ed'],
        ['token', '#00A36C'],
        ['cex', '#ff697c'],
        ['dex', '#4b2caf'],
        ['defi', '#e59c23'],
        ['mev', '#FFFF00'],
        ['bridge', '#8c1434'],
        ['unknown', '#E5E4E2']
    ]);

    if (colorMap.has(key.toLowerCase())) {
        return colorMap.get(key.toLowerCase());
    } else {
        return colorMap.get('unknown');
    }
}


function getRandomClass() {
    const keys = ['eth_transfer', 'token', 'dex', 'cex', 'mev', 'unknown'];
    const randomIndex = Math.floor(Math.random() * keys.length);
    return keys[randomIndex];
}

function generateTransactionInfo(n) {
    const transactions = [];
    let total_value = 0;
    let total_gas = 0;

    for (let i = 0; i < n; i++) {
        const coinbase = Math.random() * 10000;
        const tipreward = Math.random() * 100;
        const gas_used = Math.floor(Math.random() * 10000);

        const tx = {
            hash: generateRandomString(10),
            block: Math.floor(Math.random() * 1000),
            class: getRandomClass(),
            method_id: generateRandomString(8),
            method: generateRandomString(10),
            target_label: generateRandomString(8),
            tags: [generateRandomString(6), generateRandomString(6)],
            from: generateRandomString(8),
            to: generateRandomString(8),
            data_size: Math.floor(Math.random() * 100),
            gas_limit: Math.floor(Math.random() * 100000),
            gas_used: gas_used,
            fee: Math.random() * 100,
            tip: Math.random() * 10,
            price: Math.random() * 1000,
            tip_reward: tipreward,
            tx_value: coinbase + tipreward,
            nonce: Math.floor(Math.random() * 100),
            position: i,
            coinbase: coinbase,
            transfers: [
                {
                    f: generateRandomString(8),
                    t: generateRandomString(8),
                    a: generateRandomString(10),
                    s: generateRandomString(4),
                    q: generateRandomString(6),
                    d: Math.floor(Math.random() * 10)
                },
                {
                    f: generateRandomString(8),
                    t: generateRandomString(8),
                    a: generateRandomString(10),
                    s: generateRandomString(4),
                    q: generateRandomString(6),
                    d: Math.floor(Math.random() * 10)
                }
            ],
            timestamp: Date.now()
        };

        transactions.push(tx);

        total_value += coinbase + tipreward;
        total_gas += gas_used;
    }

    return transactions;
}

function xPos(transactions, fields, order) {
    let total = 0
    for (let i = 0; i < transactions.length; i++) {
        var v = 0
        for (let j = 0; j < fields.length; j++) {
            v += transactions[i][fields[j]];
        }
        total += v
    }
    let min = 0.0001 * total
    let pos = 0
    for (let i = 0; i < transactions.length; i++) {
        var w = 0
        for (let j = 0; j < fields.length; j++) {
            w += transactions[i][fields[j]];
        }
        if (w === 0) {
            w = min
            total += min
        }
        transactions[i].x_width = w
        transactions[i].x_pos = pos
        pos += w
    }
    var minTick;
    var maxTick;
    if (order === "position") {
        minTick = 0
        maxTick = transactions[transactions.length - 1].position
    }
    return { transactions, total, minTick, maxTick };
}

function generateRandomString(length) {
    const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    return result;
}